var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequests(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Colorful / requests") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Carpool-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Discovery-/-with-request-on-Sidebar",
    transform: "translate(-152.000000, -524.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Colorful-/-requests",
    transform: "translate(152.000000, 524.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-57",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(3.000000, 6.000000)",
    fill: "#6173FE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0295203,10 C3.63436162,10 0,13.6802597 0,18.2044199 C1.89080109e-16,19.7483762 1.25162385,21 2.79558011,21 L13.2044199,21 C14.7483762,21 16,19.7483762 16,18.2044199 L16,18.2044199 L16,18.2044199 C16,13.6802597 12.424679,10 8.0295203,10 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C5.24328571,0 3,2.24328571 3,5 C3,7.75671429 5.24328571,10 8,10 C10.7567143,10 13,7.75671429 13,5 C13,2.24328571 10.7567143,0 8,0 Z",
    id: "Path",
    opacity: 0.160529
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.3362446,12.3802288 C29.2747361,14.5760285 27.1229618,15.9990524 24.75,16 C24.1625663,16.0015834 22.2458997,16.0015834 19,16 C18,16 18.0832478,15.1895542 19,15 C20.387102,14.5822348 20.8361857,14.1206133 20.3472512,13.6151355 C19.6138494,12.8569188 18.5137468,11.7195937 18.459824,9.48205266 C18.4006843,7.02803592 19.8028429,4.78365316 21.9242746,3.68752935 C22.7946214,3.23304077 23.7565018,2.99751889 24.7298491,3.00006008 L25.096207,3.00118088 C28.2805542,3.1828028 30.8231943,5.81147327 30.9999654,9.14114975 L30.9999654,9.48145298 C31.0022765,10.4891987 30.774468,11.4832942 30.3362446,12.3802288 Z",
    id: "Path-2",
    fill: "#6173FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3529886,10.2349975 C25.1176629,10.5783325 24.8333333,10.7120629 24.5,10.6361886 C24.1666667,10.5603143 23.9596894,10.4096498 23.8790683,10.184195 C23.8790683,9.40213815 24.4525781,9.08951233 24.8859696,8.83830023 C25.2576082,8.62290369 25.4853827,8.47640341 25.4853827,8.19114794 C25.4853827,7.81382659 25.0198239,7.56338025 24.6434448,7.56338025 C24.281508,7.56338025 24.0632801,7.69401685 23.8458994,7.92929172 C23.7685382,8.01302108 23.4435372,8.33700758 22.9717686,8.04350379 C22.5,7.75 22.7306422,7.27070397 22.7941013,7.19025108 C23.2661493,6.59179272 23.8646,6.26043355 24.7386559,6.26043355 C25.777132,6.26043355 26.8856144,7.09847815 26.8856144,8.20326878 C26.8856144,9.67028442 25.3529886,9.69286331 25.3529886,10.2349975 Z M25.5048735,11.8614 C25.5048735,12.3680905 25.1061466,12.7803086 24.616039,12.7803086 C24.1259315,12.7803086 23.7272046,12.3680905 23.7272046,11.8614 C23.7272046,11.3547094 24.1259315,10.9424914 24.616039,10.9424914 C25.1061466,10.9424914 25.5048735,11.3547094 25.5048735,11.8614 Z",
    id: "Shape",
    fill: "#EBECFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequests);
export default __webpack_public_path__ + "static/media/requests.a27a842d.svg";
export { ForwardRef as ReactComponent };